module.exports = __webpack_public_path__ + "img/voellerei.90846736.png";